<template>
	<div id="app">

        <div class="card border-primary" style="margin-bottom:20px;">
			<div class="card-header">
				<h5 style="margin-bottom:0px;">BetRadar NCAAB Scores</h5>
			</div>
			<div class="card-body">
				<div class="form-row">
					<div class="col">
						<div class="form-group">
							<label>Year</label>
							<select @change="selectYear" class="form-control">
								<option value="">-- Select --</option>
								<option value="2017">2017</option>
                                <option value="2018" selected>2018</option>
                                <option value="2019">2019</option>
							</select>
						</div>
					</div>
					<div class="col">
						<div class="form-group">
							<label>Season</label>
							<select @change="selectSeason" class="form-control">
								<option value="">-- Select --</option>
								
                                <option value="REG" selected>REG - Regular season</option>
                                <option value="CT">CT - Conference Tournament</option>
                                <option value="PST">PST - Past season</option>
							</select>
						</div>
					</div>
                    <div class="col">
						<div class="form-group" v-if="schedule.games">
							<label>Games</label>
							<select @change="selectSportEvent" class="form-control">
								<option value="">-- Select --</option>
                                <option v-for="sport_event in schedule.games" :value="sport_event.id">
                                    {{ sport_event.scheduled }} - {{ sport_event.status }} - {{ getSportEventName(sport_event) }}
                                </option>
							</select>
						</div>
					</div>
				</div>
				
				<div>
					<p>These are the BetRadar endpoints used to build this page.</p>
					<table class="table" style="text-align:left;">
						<tr>
							<td>Schedule</td>
							<td>
                                <a :href="getScheduleEndpoint(true)" target="_blank">{{ getScheduleEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr>
							<td>League Hierarchy</td>
							<td>
                                <a :href="getLeagueHierarchyEndpoint(true)" target="_blank">{{ getLeagueHierarchyEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr v-if="getPlayByPlayEndpoint()">
                            <td>Play by Play</td>
							<td>
                                <a :href="getPlayByPlayEndpoint(true)" target="_blank">{{ getPlayByPlayEndpoint(true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getGameBoxscoreEndpoint()">
                            <td>Game Boxscore</td>
							<td>
                                <a :href="getGameBoxscoreEndpoint(true)" target="_blank">{{ getGameBoxscoreEndpoint(true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getGameSummaryEndpoint()">
                            <td>Game Summary</td>
							<td>
                                <a :href="getGameSummaryEndpoint(true)" target="_blank">{{ getGameSummaryEndpoint(true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getTeamRosterEndpoint(this.home)">
                            <td>Team Roster Home Team</td>
							<td>
                                <a :href="getTeamRosterEndpoint(this.home, true)" target="_blank">{{ getTeamRosterEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getTeamRosterEndpoint(this.away)">
                            <td>Team Roster Away Team</td>
							<td>
                                <a :href="getTeamRosterEndpoint(this.away, true)" target="_blank">{{ getTeamRosterEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getSeasonalStatisticsEndpoint(this.home)">
                            <td>Seasonal Statistics Home Team</td>
							<td>
                                <a :href="getSeasonalStatisticsEndpoint(this.home, true)" target="_blank">{{ getSeasonalStatisticsEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getTeamRosterEndpoint(this.away)">
                            <td>Seasonal Statistics Away Team</td>
							<td>
                                <a :href="getSeasonalStatisticsEndpoint(this.away, true)" target="_blank">{{ getSeasonalStatisticsEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getSeriesStatisticsEndpoint(this.home)">
                            <td>Series Statistics Home Team</td>
							<td>
                                <a :href="getSeriesStatisticsEndpoint(this.home, true)" target="_blank">{{ getSeriesStatisticsEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getSeriesStatisticsEndpoint(this.away)">
                            <td>Series Statistics Away Team</td>
							<td>
                                <a :href="getSeriesStatisticsEndpoint(this.away, true)" target="_blank">{{ getSeriesStatisticsEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>
					</table>
				</div>
				
			</div>
		</div>

        <div id="accordion2">
            <div class="card">
                <div class="card-header" id="headingOne">
                    <h5 class="mb-0">
                        <button class="btn btn-link" data-toggle="collapse" data-target="#schedule" aria-expanded="true" aria-controls="collapseOne">
                        Schedule
                        </button>
                    </h5>
                </div>

                <div id="schedule" class="collapse show" aria-labelledby="headingOne">
                    <div class="card-body">
                        
                        <div class="card" v-if="schedule.games != [] && league_hierarchy != []">

                            Only D1 games: {{ division_1_total_games }}<br>
                            Mixed D1 games: {{ division_1_mixed_games}}<br>
                            Not D1 games: {{ not_division_1_games }}

                            <table class="table">
                                <tr>
                                    <th>scheduled</th>
                                    <th>home</th>
                                    <th>away</th>
                                    <th>status</th>
                                </tr>
                                <tr v-for="sport_event in schedule.games.slice(1, 2)">
                                    <td>{{ sport_event.scheduled }}</td>
                                    <td>
                                        {{ sport_event.home.name }}
                                    
                                        <template v-for="division in league_hierarchy.divisions">
                                            <template v-for="conference in division.conferences">
                                                <template v-for="team in conference.teams">
                                                    <div v-if="team.id == sport_event.home.id">
                                                        conference: {{ conference.name }}<br>
                                                        division: {{ division.name }}
                                                    </div>
                                                </template>
                                            </template>
                                        </template>
                                    </td>
                                    <td>
                                        {{ sport_event.away.name }}

                                        <template v-for="division in league_hierarchy.divisions">
                                            <template v-for="conference in division.conferences">
                                                <template v-for="team in conference.teams">
                                                    <div v-if="team.id == sport_event.away.id">
                                                        conference: {{ conference.name }}<br>
                                                        division: {{ division.name }}
                                                    </div>
                                                </template>
                                            </template>
                                        </template>
                                    </td>
                                    <td>{{ sport_event.status }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="sportEventId">
            <div id="accordion">
                <div class="card">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game" aria-expanded="true" aria-controls="collapseOne">
							Game
							</button>
						</h5>
					</div>

					<div id="game" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
							<table class="table">
                                <tr>
                                    <th>scheduled</th>
                                    <th>home</th>
                                    <th>away</th>
                                    <th>venue</th>
                                    <th>broadcasts</th>
                                </tr>
                                <tr>
                                    <td>
                                        {{ sport_event.scheduled }}<br>
                                        id: {{ sport_event.id }}<br>
                                        status: {{ sport_event.status }}
                                    </td>
                                    <td>
                                        name: {{ sport_event.home.name }}<br>
                                        alias: {{ sport_event.home.alias }}<br>
                                        id: {{ sport_event.home.id }}<br>
                                        sr_id: {{ sport_event.home.sr_id }}<br>
                                        reference: {{ sport_event.home.reference }}<br>
                                    </td>
                                    <td>
                                        name: {{ sport_event.away.name }}<br>
                                        alias: {{ sport_event.away.alias }}<br>
                                        id: {{ sport_event.away.id }}<br>
                                        sr_id: {{ sport_event.away.sr_id }}<br>
                                        reference: {{ sport_event.away.reference }}<br>
                                    </td>
                                    <td>
                                        name: {{ sport_event.venue.name }}<br>
                                        id: {{ sport_event.venue.id }}<br>
                                        address: {{ sport_event.venue.address }}<br>
                                        city: {{ sport_event.venue.city }}<br>
                                        state: {{ sport_event.venue.state }}<br>
                                        country: {{ sport_event.venue.country }}<br>
                                        zip: {{ sport_event.venue.zip }}<br>
                                        capacity: {{ sport_event.venue.capacity }}<br>
                                        surface: {{ sport_event.venue.surface }}<br>
                                        type: {{ sport_event.venue.type }}<br>
                                    </td>
                                    <td>
                                        <div v-if="sport_event.broadcasts">
                                            <div v-for="broadcast in sport_event.broadcasts">
                                                network: {{ broadcast.network }}<br>
                                                channel: {{ broadcast.channel }}<br>
                                                locale: {{ broadcast.locale }}<br>
                                                type: {{ broadcast.type }}<br>
                                            </div>
                                            
                                        </div>
                                    </td>
                                </tr>
                            </table>

						</div>
					</div>
				</div>

                <div class="card" v-if="play_by_play != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#playbyplay" aria-expanded="true" aria-controls="collapseOne">
							Play by Play
							</button>
						</h5>
					</div>

					<div id="playbyplay" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
							<table class="table">
                                <tr>
                                    <th></th>
                                    <th>home</th>
                                    <th>away</th>
                                    <th>time_zones</th>
                                </tr>
                                <tr>
                                    <td>
                                        duration: {{ play_by_play.duration }}<br>
                                        attendance: {{ play_by_play.attendance }}<br>
                                        lead_changes: {{ play_by_play.lead_changes }}<br>
                                        times_tied: {{ play_by_play.times_tied }}<br>
                                    </td>
                                    <td>
                                        <div v-if="play_by_play.home">
                                            id: {{ play_by_play.home.id }}<br>
                                            market: {{ play_by_play.home.market }}<br>
                                            name: {{ play_by_play.home.name }}<br>
                                            points: {{ play_by_play.home.points }}<br>
                                            bonus: {{ play_by_play.home.bonus }}<br>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="play_by_play.away">
                                            id: {{ play_by_play.away.id }}<br>
                                            market: {{ play_by_play.away.market }}<br>
                                            name: {{ play_by_play.away.name }}<br>
                                            points: {{ play_by_play.away.points }}<br>
                                            bonus: {{ play_by_play.away.bonus }}<br>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="play_by_play.time_zones">
                                            venue: {{ play_by_play.time_zones.venue }}<br>
                                            home: {{ play_by_play.time_zones.home }}<br>
                                            away: {{ play_by_play.time_zones.away }}<br>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <div v-for="period in play_by_play.periods">

                                <h3>Period - {{ period.number}}</h3>

                                home score: {{ period.scoring.home.points }}<br>
                                away score: {{ period.scoring.away.points }}<br>
                                lead_changes: {{ period.scoring.lead_changes }}<br>
                                times_tied: {{ period.scoring.times_tied }}<br>

                                <table class="table">
                                    <tr>
                                        <th>clock</th>
                                        <th></th>
                                        <th>points</th>
                                        <th>location</th>
                                        <th>on_court home</th>
                                        <th>on_court away</th>
                                        <th>statistics</th>  
                                    </tr>
                                    <tr v-for="pbp in period.events">
                                        <td>{{ pbp.clock }}</td>
                                        <td>
                                            id: {{ pbp.id }}<br>
                                            <span v-if="pbp.type"> type: {{ pbp.type }}<br></span>
                                            <span v-if="pbp.event_type"> event_type: {{ pbp.event_type }}<br></span>
                                            <span v-if="pbp.sequence"> sequence: {{ pbp.sequence }}<br></span>
                                            <span v-if="pbp.description"> summary: {{ pbp.description }}<br></span>
                                            <span v-if="pbp.updated"> updated: {{ pbp.updated }}<br></span>
                                            <span v-if="pbp.number"> number: {{ pbp.number }}<br></span>
                                            <span v-if="pbp.wall_clock"> wall_clock: {{ pbp.wall_clock }}<br></span>
                                            
                                            <div v-if="pbp.attribution">
                                                attribution: {{ pbp.attribution.market }} {{ pbp.attribution.name }}
                                            </div>
                                        </td>
                                        <td>
                                            <span v-if="pbp.home_points"> home_points: {{ pbp.home_points }}<br></span>
                                            <span v-if="pbp.away_points"> away_points: {{ pbp.away_points }}<br></span>
                                        </td>
                                        <td>
                                            <div v-if="pbp.location">
                                                <span v-if="pbp.location.action_area"> action_area: {{ pbp.location.action_area }}<br></span>
                                                <span v-if="pbp.location.coord_x"> coord_x: {{ pbp.location.coord_x }}<br></span>
                                                <span v-if="pbp.location.coord_y"> coord_y: {{ pbp.location.coord_y }}<br></span>
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if=" pbp.on_court">
                                                <div v-for="player in pbp.on_court.home.players">
                                                    {{ player.full_name }} - jersey: {{ player.jersey_number }}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if=" pbp.on_court">
                                                <div v-for="player in pbp.on_court.away.players">
                                                    {{ player.full_name }} - jersey: {{ player.jersey_number }}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if="pbp.statistics">

                                                <div v-for="pbpstat in pbp.statistics" style="border-bottom:1px solid #ccc;">
                                                    type: {{ pbpstat.type }}<br>
                                                    <span v-if="pbpstat.made">made: {{ pbpstat.made }}<br></span>
                                                    <span v-if="pbpstat.shot_type">shot_type: {{ pbpstat.shot_type }}<br></span>
                                                    <span v-if="pbpstat.shot_type_desc">shot_type_desc: {{ pbpstat.shot_type_desc }}<br></span>
                                                    <span v-if="pbpstat.points">points: {{ pbpstat.points }}<br></span>
                                                    <span v-if="pbpstat.shot_distance">shot_distance: {{ pbpstat.shot_distance }}<br></span>
                                                    <span v-if="pbpstat.team">team: {{ pbpstat.team.name }}<br></span>
                                                    <span v-if="pbpstat.player">player: {{ pbpstat.player.full_name }}<br></span>
                                                </div>

                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
						</div>
					</div>
				</div>

                <div class="card" v-if="game_boxscore != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game-boxscore" aria-expanded="true" aria-controls="collapseOne">
							Game Boxscore
							</button>
						</h5>
					</div>

					<div id="game-boxscore" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
							<table class="table">
                                <tr>
                                    <th></th>
                                    <th>home team scoring</th>
                                    <th>away team scoring</th>
                                </tr>
                                <tr>
                                    <td>
                                        clock: {{ game_boxscore.clock }}<br>
                                        half: {{ game_boxscore.half }}<br>
                                        status: {{ game_boxscore.status }}<br>
                                        conference_game: {{ game_boxscore.conference_game }}<br>
                                    </td>
                                    <td>
                                        
                                        <div v-if="game_boxscore.home">
                                            points: {{ game_boxscore.home.points }}<br>
                                            <div v-for="scoring in game_boxscore.home.scoring" style="border-top: 1px solid #ccc">
                                                points: {{ scoring.points }}<br>
                                                type: {{ scoring.type }}<br>
                                                number: {{ scoring.number }}<br>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        
                                        <div v-if="game_boxscore.away">
                                            points: {{ game_boxscore.away.points }}<br>
                                            <div v-for="scoring in game_boxscore.away.scoring" style="border-top: 1px solid #ccc">
                                                points: {{ scoring.points }}<br>
                                                type: {{ scoring.type }}<br>
                                                number: {{ scoring.number }}<br>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <h3>leaders</h3>

                            <table class="table" v-if="game_boxscore.home">
                                <tr>
                                    <th></th>
                                    <th>home</th>
                                    <th>away</th>
                                </tr>
                                <tr>
                                    <td>
                                        points
                                    </td>
                                    <td>
                                        <div v-for="player in game_boxscore.home.leaders.points">
                                            full_name: {{ player.full_name }}<br>
                                            jersey_number: {{ player.jersey_number }}<br>
                                            position: {{ player.position }}<br>
                                            primary_position: {{ player.primary_position }}<br>
                                            id: {{ player.id }}<br>
                                            sr_id: {{ player.sr_id }}<br>
                                            <span v-for="field in game_boxscore_leader_statistic_fields">
                                                {{ field }}: {{ player.statistics[field] }}<br>
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-for="player in game_boxscore.away.leaders.points">
                                            full_name: {{ player.full_name }}<br>
                                            jersey_number: {{ player.jersey_number }}<br>
                                            position: {{ player.position }}<br>
                                            primary_position: {{ player.primary_position }}<br>
                                            id: {{ player.id }}<br>
                                            sr_id: {{ player.sr_id }}<br>
                                            <span v-for="field in game_boxscore_leader_statistic_fields">
                                                {{ field }}: {{ player.statistics[field] }}<br>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        rebounds
                                    </td>
                                    <td>
                                        <div v-for="player in game_boxscore.home.leaders.rebounds">
                                            full_name: {{ player.full_name }}<br>
                                            jersey_number: {{ player.jersey_number }}<br>
                                            position: {{ player.position }}<br>
                                            primary_position: {{ player.primary_position }}<br>
                                            id: {{ player.id }}<br>
                                            sr_id: {{ player.sr_id }}<br>
                                            <span v-for="field in game_boxscore_leader_statistic_fields">
                                                {{ field }}: {{ player.statistics[field] }}<br>
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-for="player in game_boxscore.away.leaders.rebounds">
                                            full_name: {{ player.full_name }}<br>
                                            jersey_number: {{ player.jersey_number }}<br>
                                            position: {{ player.position }}<br>
                                            primary_position: {{ player.primary_position }}<br>
                                            id: {{ player.id }}<br>
                                            sr_id: {{ player.sr_id }}<br>
                                            <span v-for="field in game_boxscore_leader_statistic_fields">
                                                {{ field }}: {{ player.statistics[field] }}<br>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        assists
                                    </td>
                                    <td>
                                        <div v-for="player in game_boxscore.home.leaders.assists">
                                            full_name: {{ player.full_name }}<br>
                                            jersey_number: {{ player.jersey_number }}<br>
                                            position: {{ player.position }}<br>
                                            primary_position: {{ player.primary_position }}<br>
                                            id: {{ player.id }}<br>
                                            sr_id: {{ player.sr_id }}<br>
                                            <span v-for="field in game_boxscore_leader_statistic_fields">
                                                {{ field }}: {{ player.statistics[field] }}<br>
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-for="player in game_boxscore.away.leaders.assists">
                                            full_name: {{ player.full_name }}<br>
                                            jersey_number: {{ player.jersey_number }}<br>
                                            position: {{ player.position }}<br>
                                            primary_position: {{ player.primary_position }}<br>
                                            id: {{ player.id }}<br>
                                            sr_id: {{ player.sr_id }}<br>
                                            <span v-for="field in game_boxscore_leader_statistic_fields">
                                                {{ field }}: {{ player.statistics[field] }}<br>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </table>
						</div>
					</div>
				</div>

                <div class="card" v-if="game_summary != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game-summary" aria-expanded="true" aria-controls="collapseOne">
							Game Summary
							</button>
						</h5>
					</div>

					<div id="game-summary" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>home_team</h3>

                            <table class="table" v-if="game_summary.home">
                                <tr>
                                    <th>statistics</th>
                                    <th>players</th>
                                    <th>coaches</th>
                                </tr>
                                <tr>
                                    <td>
                                        <div v-for="(value, name) in game_summary.home.statistics">
                                            <div v-if="typeof(value) == 'object'">
                                                
                                                {{ name }}: 
                                                <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                            
                                                    <div v-if="typeof(value_2) == 'object'">
                                                
                                                        {{ name_2 }}: 
                                                        <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                            
                                                            {{ name_3 }}: {{ value_3 }}
                                                        
                                                        </div>

                                                    </div>
                                                    <div v-else>
                                                        {{ name_2 }}: {{ value_2 }}
                                                    </div>
                                                
                                                </div>

                                            </div>
                                            <div v-else>
                                                {{ name }}: {{ value }}
                                            </div>
                                            
                                        </div> 
                                    </td>
                                    <td>
                                        <div v-for="player in game_summary.home.players">
                                            <b>{{ player.full_name}}</b>
                                            <div v-for="(value, name) in player.statistics">
                                                <div v-if="typeof(value) == 'object'">
                                                    
                                                    {{ name }}: 
                                                    <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                                
                                                        <div v-if="typeof(value_2) == 'object'">
                                                    
                                                            {{ name_2 }}: 
                                                            <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                                
                                                                {{ name_3 }}: {{ value_3 }}
                                                            
                                                            </div>

                                                        </div>
                                                        <div v-else>
                                                            {{ name_2 }}: {{ value_2 }}
                                                        </div>
                                                    
                                                    </div>

                                                </div>
                                                <div v-else>
                                                    {{ name }}: {{ value }}
                                                </div>
                                                
                                            </div> 
                                            <br><br>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-for="(value, name) in game_summary.home.coaches">
                                            <div v-if="typeof(value) == 'object'">
                                                
                                                {{ name }}: 
                                                <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                            
                                                    <div v-if="typeof(value_2) == 'object'">
                                                
                                                        {{ name_2 }}: 
                                                        <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                            
                                                            {{ name_3 }}: {{ value_3 }}
                                                        
                                                        </div>

                                                    </div>
                                                    <div v-else>
                                                        {{ name_2 }}: {{ value_2 }}
                                                    </div>
                                                
                                                </div>

                                            </div>
                                            <div v-else>
                                                {{ name }}: {{ value }}
                                            </div>
                                            
                                        </div> 
                                    </td>
                                </tr>
                            </table>
                            

                            <h3>away_team</h3>

                            <table class="table" v-if="game_summary.away">
                                <tr>
                                    <th>statistics</th>
                                    <th>players</th>
                                    <th>coaches</th>
                                </tr>
                                <tr>
                                    <td>
                                        <div v-for="(value, name) in game_summary.away.statistics">
                                            <div v-if="typeof(value) == 'object'">
                                                
                                                {{ name }}: 
                                                <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                            
                                                    <div v-if="typeof(value_2) == 'object'">
                                                
                                                        {{ name_2 }}: 
                                                        <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                            
                                                            {{ name_3 }}: {{ value_3 }}
                                                        
                                                        </div>

                                                    </div>
                                                    <div v-else>
                                                        {{ name_2 }}: {{ value_2 }}
                                                    </div>
                                                
                                                </div>

                                            </div>
                                            <div v-else>
                                                {{ name }}: {{ value }}
                                            </div>
                                            
                                        </div> 
                                    </td>
                                    <td>
                                        <div v-for="player in game_summary.away.players">
                                            <b>{{ player.full_name}}</b>
                                            <div v-for="(value, name) in player.statistics">
                                                <div v-if="typeof(value) == 'object'">
                                                    
                                                    {{ name }}: 
                                                    <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                                
                                                        <div v-if="typeof(value_2) == 'object'">
                                                    
                                                            {{ name_2 }}: 
                                                            <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                                
                                                                {{ name_3 }}: {{ value_3 }}
                                                            
                                                            </div>

                                                        </div>
                                                        <div v-else>
                                                            {{ name_2 }}: {{ value_2 }}
                                                        </div>
                                                    
                                                    </div>

                                                </div>
                                                <div v-else>
                                                    {{ name }}: {{ value }}
                                                </div>
                                                
                                            </div> 
                                            <br><br>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-for="(value, name) in game_summary.away.coaches">
                                            <div v-if="typeof(value) == 'object'">
                                                
                                                {{ name }}: 
                                                <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                            
                                                    <div v-if="typeof(value_2) == 'object'">
                                                
                                                        {{ name_2 }}: 
                                                        <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                            
                                                            {{ name_3 }}: {{ value_3 }}
                                                        
                                                        </div>

                                                    </div>
                                                    <div v-else>
                                                        {{ name_2 }}: {{ value_2 }}
                                                    </div>
                                                
                                                </div>

                                            </div>
                                            <div v-else>
                                                {{ name }}: {{ value }}
                                            </div>
                                            
                                        </div> 
                                    </td>
                                </tr>
                            </table>                           

						</div>
					</div>
				</div>

                <div class="card" v-if="team_roster_home != [] && team_roster_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#team-roster" aria-expanded="true" aria-controls="collapseOne">
							Team Roster
							</button>
						</h5>
					</div>

					<div id="team-roster" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <NBARoster
                                :roster="team_roster_home"
                                team_role="home_team"
                            ></NBARoster>

                            <NBARoster
                                :roster="team_roster_away"
                                team_role="away_team"
                            ></NBARoster>
                                            
						</div>
					</div>
				</div>

                <div class="card" v-if="seasonal_statistics_home != [] && seasonal_statistics_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#seasonal-statistics" aria-expanded="true" aria-controls="collapseOne">
							Seasonal Statistics
							</button>
						</h5>
					</div>

					<div id="seasonal-statistics" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>home_team</h3>

                            <div v-if="seasonal_statistics_home">
                                <NBASeasonalStatistics
                                    :statistics="seasonal_statistics_home"
                                ></NBASeasonalStatistics>
                            </div>
                            

                            <h3>away_team</h3>

                            <div v-if="seasonal_statistics_away">
                                <NBASeasonalStatistics
                                    :statistics="seasonal_statistics_away"
                                ></NBASeasonalStatistics>
                            </div>
                                            
						</div>
					</div>
				</div>

                <div class="card" v-if="team_roster_home != [] && team_roster_away != []">
                    <div class="card-header" id="headingFive">
                        <h5 class="mb-0">
                            <button class="btn btn-link" data-toggle="collapse" data-target="#collapsePlayerProfile" aria-expanded="true" aria-controls="collapseOne">
                            Player Profile
                            </button>
                        </h5>
                    </div>

                    <div id="collapsePlayerProfile" class="collapse show" aria-labelledby="collapseFour">
                        <div class="card-body">

                            <select class="form-control" @change="selectPlayer">
                                <option value="">-- Select --</option>
                                <option v-for="player in team_roster_home.players" :value="player.id">
                                    {{ player.full_name }}
                                </option>
                                <option v-for="player in team_roster_away.players" :value="player.id">
                                    {{ player.full_name }}
                                </option>
                            </select>
                            
                            <div v-if="player_profile">

                                <table class="table">
                                    <tr>
                                        <th>id</th>
                                        <th>last_name</th>
                                        <th>first_name</th>
                                        <th>birthdate</th>
                                        <th>birth_place</th>
                                        <th>height</th>
                                        <th>weight</th>
                                        <th>college</th>
                                        <th>draft</th>
                                        <th>experience</th>
                                        <th>jersey_number</th>
                                        <th>position</th>
                                        <th>primary_position</th>
                                        <th>status</th>
                                        <th>team</th>
                                        <th>draft</th>
                                    </tr>
                                    <tr>
                                        <td>{{ player_profile.id }}</td>
                                        <td>{{ player_profile.last_name }}</td>
                                        <td>{{ player_profile.first_name }}</td>
                                        <td>{{ player_profile.birthdate }}</td>
                                        <td>{{ player_profile.birth_place }}</td>
                                        <td>{{ player_profile.height }}</td>
                                        <td>{{ player_profile.weight }}</td>
                                        <td>{{ player_profile.college }}</td>
                                        <td>{{ player_profile.draft }}</td>
                                        <td>{{ player_profile.experience }}</td>
                                        <td>{{ player_profile.jersey_number }}</td>
                                        <td>{{ player_profile.position }}</td>
                                        <td>{{ player_profile.primary_position }}</td>
                                        <td>{{ player_profile.status }}</td>
                                        <td>
                                            <span v-if="player_profile.team">
                                                {{ player_profile.team.market }} {{ player_profile.team.name }}
                                            </span>
                                        </td>
                                        <td>
                                            <span v-if="player_profile.draft">
                                                pick: {{ player_profile.draft.pick }}<br>
                                                round: {{ player_profile.draft.round }}<br>
                                                year: {{ player_profile.draft.year }}<br>
                                            </span>
                                        </td>
                                    </tr>
                                </table>

                                <h3>seasons</h3>

                                <table class="table" v-if="player_profile.seasons">
                                    <tr>
                                        <th>year</th>
                                        <th>type</th>
                                        <th>team</th>
                                        <th>total</th>
                                        <th>average</th>
                                    </tr>
                                    <template v-for="season in player_profile.seasons">
                                        <tr v-for="team in season.teams">
                                            <td>{{ season.year }}</td>
                                            <td>{{ season.type }}</td>
                                            <td>{{ team.market }} {{ team.name }}</td>
                                            <td>
                                                <div v-for="value, name in team.total">
                                                    {{ name }}: {{ value }}
                                                </div>
                                            </td>
                                            <td>
                                                <div v-for="value, name in team.average">
                                                    {{ name }}: {{ value }}
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'
import NBARoster from './components/NBARoster.vue'
import NBASeasonalStatistics from './components/NBASeasonalStatistics.vue'

export default {
    name: 'app',
    components: {
        NBARoster,
        NBASeasonalStatistics,
	},
    created: function() {

        this.loadSchedule();
        //this.loadLeagueHierarchy();
    
    },
    data: function() {
        return {            
            apiKey: 'wwfykys28uth3vfha8pxf8st',
            year: 2018,
            season: "REG",
            schedule: [],
            league_hierarchy: [],
            division_1_teams: [],
            division_1_total_games: 0,
            division_1_mixed_games: 0,
            not_division_1_games: 0,
            play_by_play: [],
            sportEventId: '',
            sport_event: '',
            home: '',
            away: '',
            game_boxscore: [],
            game_summary: [],
            seasonal_statistics_home: [],
            seasonal_statistics_away: [],
            team_depth_chart_home: [],
            team_depth_chart_away: [],
            team_roster_home: [],
            team_roster_away: [],
            game_boxscore_leader_statistic_fields: [
                'minutes',
                'field_goals_made',
                'field_goals_att',
                'field_goals_pct',
                'three_points_made',
                'three_points_att',
                'three_points_pct',
                'two_points_made',
                'two_points_att',
                'two_points_pct',
                'blocked_att',
                'free_throws_made',
                'free_throws_att',
                'free_throws_pct',
                'offensive_rebounds',
                'defensive_rebounds',
                'rebounds',
                'assists',
                'turnovers',
                'steals',
                'blocks',
                'assists_turnover_ratio',
                'personal_fouls',
                'tech_fouls',
                'flagrant_fouls',
                'pls_min',
                'points',
                'double_double',
                'triple_double',
                'effective_fg_pct',
                'efficiency',
                'efficiency_game_score',
                'points_in_paint',
                'points_in_paint_att',
                'points_in_paint_made',
                'points_in_paint_pct',
                'true_shooting_att',
                'true_shooting_pct',
                'fouls_drawn',
                'offensive_fouls',
                'points_off_turnovers',
                'second_chance_pts',
            ],
            playerId: '',
            player_profile: [],
        }
    }, 
    methods: {
        getScheduleEndpoint: function(showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/ncaamb/trial/v7/en/games/${this.year}/${this.season}/schedule.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getLeagueHierarchyEndpoint: function(showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/ncaamb/trial/v7/en/league/hierarchy.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getPlayByPlayEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.sportEventId == '') {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/ncaamb/trial/v7/en/games/${this.sportEventId}/pbp.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getGameBoxscoreEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.sportEventId == '') {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/ncaamb/trial/v7/en/games/${this.sportEventId}/boxscore.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getGameSummaryEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.sportEventId == '') {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/ncaamb/trial/v7/en/games/${this.sportEventId}/summary.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getSeasonalStatisticsEndpoint: function(team, showBetradarUrl = false) {
            
            if(team == '') return '';
            
            let url = `https://kaxmatrix.com/oddsapi/ncaamb/trial/v7/en/seasons/${this.year}/${this.season}/teams/${team.id}/statistics.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getSeriesStatisticsEndpoint: function(team, showBetradarUrl = false) {
            
            if(team == '') return '';
            
            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/series/${this.year}/${this.season}/teams/${team.id}/statistics.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getTeamRosterEndpoint: function(team, showBetradarUrl = false) {

            if(team == '') return '';

            let url = `https://kaxmatrix.com/oddsapi/ncaamb/trial/v7/en/teams/${team.id}/profile.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getPlayerProfileEndpoint: function(showBetradarUrl = false) {
			let url = `https://kaxmatrix.com/oddsapi/ncaamb/trial/v7/en/players/${this.playerId}/profile.json?api_key=${this.apiKey}`;

			if(showBetradarUrl) {
				url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
			}

			return url;
		},

        loadSchedule: function() {

            // get full list of tournaments
            axios.get(this.getScheduleEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('schedule', response.data);

                this.schedule = response.data;
                
                this.loadLeagueHierarchy();
            
            }, (error) => {
                console.log(error)
            });
        },

        loadLeagueHierarchy: function() {

            // get full list of tournaments
            axios.get(this.getLeagueHierarchyEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('league_hierarchy', response.data);

                this.league_hierarchy = response.data;
                
                this.division_1_teams = [];

                for(var i = 0; i < this.league_hierarchy.divisions.length; i++) {

                    if(this.league_hierarchy.divisions[i].name == "NCAA Division I") {

                        for(var j = 0; j < this.league_hierarchy.divisions[i].conferences.length; j++) {
                            
                            for(var z = 0; z < this.league_hierarchy.divisions[i].conferences[j].teams.length; z++) {
                                
                                this.division_1_teams.push(this.league_hierarchy.divisions[i].conferences[j].teams[z].id);
                            }
                        }
                    }
                }

                var division_1_total_games = 0;
                var division_1_mixed_games = 0;
                var not_division_1_games = 0;

                for(var i = 0; i < this.schedule.games.length; i++) {

                    if(this.division_1_teams.indexOf(this.schedule.games[i].home.id) > -1
                        && this.division_1_teams.indexOf(this.schedule.games[i].away.id) > -1
                    ) {
                        division_1_total_games++;
                    }
                    else if(this.division_1_teams.indexOf(this.schedule.games[i].home.id) > -1
                        || this.division_1_teams.indexOf(this.schedule.games[i].away.id) > -1
                    ) {
                        division_1_mixed_games++;
                    }
                    else {
                        not_division_1_games++;
                    }
                }

                this.division_1_total_games = division_1_total_games;
                this.division_1_mixed_games = division_1_mixed_games;
                this.not_division_1_games = not_division_1_games;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadPlayByPlay: function() {

            if(this.getPlayByPlayEndpoint() == '') return;

            axios.get(this.getPlayByPlayEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('play-by-play', response.data);

                this.play_by_play = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadGameBoxscore: function() {

            if(this.getGameBoxscoreEndpoint() == '') return;

            axios.get(this.getGameBoxscoreEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('game-boxscore', response.data);

                this.game_boxscore = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadGameSummary: function() {

            if(this.getGameSummaryEndpoint() == '') return;

            axios.get(this.getGameSummaryEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('game-summary', response.data);

                this.game_summary = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadSeasonalStatistics: function() {

            if(this.getSeasonalStatisticsEndpoint(this.home) == ''
                || this.getSeasonalStatisticsEndpoint(this.away) == ''
            ) return;

            axios.get(this.getSeasonalStatisticsEndpoint(this.home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('seasonal_statistics_home', response.data);

                this.seasonal_statistics_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getSeasonalStatisticsEndpoint(this.away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('seasonal_statistics_away', response.data);

                this.seasonal_statistics_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadTeamRoster: function() {

            if(this.getTeamRosterEndpoint(this.home) == ''
                || this.getTeamRosterEndpoint(this.away) == ''
            ) return;

            axios.get(this.getTeamRosterEndpoint(this.home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('team_roster_home', response.data);

                this.team_roster_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getTeamRosterEndpoint(this.away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('team_roster_away', response.data);

                this.team_roster_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadPlayerProfile: function() {

			axios.get(this.getPlayerProfileEndpoint(), 
                { crossdomain: true })
            .then((response) => {
				
				console.log('playerProfile', response.data);
				this.player_profile = response.data;

            }, (error) => {
                console.log(error)
			});

		},

        getSportEventName: function(sport_event) {

            let name = sport_event.home.name + ' vs ' + sport_event.away.name;

            return name;
        },

        selectYear: function(event) {
			
			this.year = event.target.value;
			this.loadSchedule();
        },

        selectSeason: function(event) {
			
			this.season = event.target.value;
			this.loadSchedule();
        },

        selectSportEvent: function(event) {
			  
            let sportEventId = event.target.value;
            let sport_event = '';
            let week = '';

                
            let temp_sport_event = this.schedule.games.find(function(game) {
                return game.id == sportEventId;
            });

            if(temp_sport_event) {
                sport_event = temp_sport_event;
            }

            this.sportEventId = event.target.value;
            this.sport_event = sport_event;
            this.home = sport_event.home;
            this.away = sport_event.away;
            
            this.loadPlayByPlay();	
            this.loadGameBoxscore();
            this.loadGameSummary();
            this.loadSeasonalStatistics();
            this.loadTeamRoster();
        },

        selectPlayer: function(event) {

            this.playerId = event.target.value;

			this.loadPlayerProfile();
        },
    },
}
</script>